<div class="alert alert-success" role="alert" *ngIf="player">
  <h4 class="alert-heading">Welcome {{ player.name }}</h4>
  <p>Aww yeah, you are almost ready to rock that Trivia!</p>
  <hr />
  <p class="mb-0">It just seems that your friends are a little slower, so let's wait for them...</p>
  <p>{{ players.join(", ") }}</p>
</div>
